export function getVacancyCategories (state) {
  return state.vacancy
}

export function getCompanyCategories (state) {
  return state.company
}



// WEBPACK FOOTER //
// ./src/vuex/categories/getters.js